import { useState } from "react";
import { ONBOARDING_STEPS, stepIndex, type OnboardingStep } from "../lib/onboarding";
import { OnboardingLayout } from "../components/onboarding/OnboardingLayout";
import { WelcomeStep } from "../components/onboarding/WelcomeStep";
import { PlaceholderStep } from "../components/onboarding/PlaceholderStep";

// Only Welcome is fully designed. Every other step renders a PlaceholderStep
// that keeps the flow navigable so a reviewer can walk end-to-end.
// Designed steps replace their PlaceholderStep branch as they land.
export function OnboardingScreen() {
  const [step, setStep] = useState<OnboardingStep>("welcome");

  const idx = stepIndex(step);
  const goNext = () => {
    const next = ONBOARDING_STEPS[idx + 1] ?? ONBOARDING_STEPS[0];
    setStep(next);
  };
  const goBack = () => {
    const prev = ONBOARDING_STEPS[idx - 1] ?? ONBOARDING_STEPS[0];
    setStep(prev);
  };
  const isLast = idx === ONBOARDING_STEPS.length - 1;

  return (
    <OnboardingLayout currentStep={step}>
      {step === "welcome" && <WelcomeStep onNext={goNext} />}
      {step !== "welcome" && (
        <PlaceholderStep step={step} onBack={goBack} onNext={goNext} isLast={isLast} />
      )}
    </OnboardingLayout>
  );
}
